// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"3eb91c59","471":"e8a91a84","550":"c0f42ab0","603":"1c1c7e58","698":"062295f1","842":"36058233","923":"df44b343","973":"29c1c3c3"}[chunkId] + ".chunk.js";
};